import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alert-notify',
  templateUrl: './alert-notify.component.html',
  styleUrls: ['./alert-notify.component.scss']
})
export class AlertNotifyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
